import React from "react";
import Footer from "./Footer";

import OnlinePayment from "../features/Payment/component/OnlinePayment";

function OnlinePaymentPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <OnlinePayment />
      <Footer />
    </div>
  );
}

export default OnlinePaymentPage;
